module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + require('./helpers/bundle-manifest').resolve("8kRrQ");